/* eslint-disable import/extensions */
import { buildNestedRouting, routeCreator as route } from '../components/Routes/CommunityRoute';
import globals from '../globals/communityGlobals';
// Page components
import DailyPlanning from '../containers/DailyPlanning/DailyPlanningContainer';
import VisitActualsPage from '../components/VisitActuals/VisitActualsPage';
import VisitActualEdit from '../containers/VisitActuals/Edit/VisitActualsEditContainer';
import PatientSearchPage from '../features/Patients/Search/PatientSearchPage';
import PatientAuditSearchPage from '../features/Patients/PatientAudit/PatientAuditSearchPage';
import PatientDetails from '../containers/Patients/Patient/PatientDetailsContainer';
import PatientAdd from '../containers/Patients/Add/PatientAddContainer';
import PatientReferrals from '../containers/Patients/PatientReferrals/PatientReferralsContainer';
import ReferralCreate from '../containers/Referrals/ReferralCreate/ReferralCreateContainer';
import ReferralView from '../containers/Referrals/ReferralView/ReferralViewContainer';
import TreatmentCreate from '../containers/Treatments/TreatmentCreate/TreatmentCreateContainer';
import TreatmentCreateRetroVisit from '../containers/Treatments/TreatmentCreate/TreatmentCreateRetroVisitContainer';
import TreatmentEdit from '../containers/Treatments/TreatmentEdit/TreatmentEditContainer';
import AuditPage from '../components/Admin/Audit/AuditPage';
import SystemInfo from '../containers/Admin/SystemInfo/SystemInfoContainer';
import ReasonsPage from '../components/Admin/Reasons/ReasonsPage';
import ActivityTypePage from '../components/Admin/ActivityTypes/ActivityTypePage';
import ActivityPage from '../components/Admin/Activities/ActivityPage';
import ConfigureTimeSlotsContainer from '../containers/Admin/ConfigureTimeSlots/ConfigureTimeSlotsContainer';
import ReportSelection from '../containers/Reports/ReportSelectionContainer';
import Dashboard from '../containers/Dashboard/DashboardContainer';
import NonPatientActivitiesPage from '../features/NonPatientActivities/NPAPage';
import NonPatientActivityCreate from '../containers/NonPatientActivities/NonPatientActivityCreateContainer';
import NonPatientActivityEdit from '../containers/NonPatientActivities/NonPatientActivityEditContainer';
import NonPatientActivityTypesList from '../components/Admin/NonPatientActivityTypes/NPActivityTypesPage';
import MileageCap from '../components/Admin/MileageCap/MileageCapPage';
import ConfigureClinician from '../components/Admin/ConfigureClinician/ConfigureClinicianPage';
// eslint-disable-next-line import/no-unresolved
import {
  TreatmentViewPage,
  TreatmentViewPageOld,
  ClinicianViewPage,
  MapViewPage,
  ClinicianGroupPage,
} from '../components/Planner';
import { CommunityLayoutCombined } from '../features/Community';
import AutoAllocateWeightings from '../containers/Admin/AutoAllocateWeightings/AutoAllocateWeightingsContainer';
import CancellingPartyPage from '../components/Admin/CancellingParties/CancellingPartiesPage';
import ReferralConfig from '../components/Admin/ReferralConfig/ReferralConfigPage';
import ExternalProvider from '../components/Admin/ExternalProvider/ExternalProviderPage';
import RequestLogsPage from '../components/Admin/ExternalProvider/ProviderRequest/RequestLogsPage';

// Renamed for readability
const fAs = globals.applicationFeatureAccesses;

// Any \ need to be escaped since we're using object keys
const routingMap = {
  '/PlannerOld': {
    '/TreatmentView': route(
      TreatmentViewPageOld,
      CommunityLayoutCombined,
      [fAs.canAllocateWork, fAs.canAccessCliniciansView],
      'plannerold',
    ),
    '/ClinicianView': route(
      ClinicianViewPage,
      CommunityLayoutCombined,
      [fAs.canAllocateWork, fAs.canAccessCliniciansView],
      'plannerold',
    ),
    '/MapView': route(
      MapViewPage,
      CommunityLayoutCombined,
      [fAs.canAllocateWork, fAs.canAccessCliniciansView],
      'plannerold',
    ),
    '/ClinicianGroups': route(
      ClinicianGroupPage,
      CommunityLayoutCombined,
      [fAs.canAllocateWork, fAs.canAccessCliniciansView],
      'plannerold',
    ),
    _default: route(
      TreatmentViewPageOld,
      CommunityLayoutCombined,
      [fAs.canAllocateWork, fAs.canAccessCliniciansView],
      'plannerold',
    ),
  },
  '/Planner': {
    '/TreatmentView': route(
      TreatmentViewPage,
      CommunityLayoutCombined,
      [fAs.canAllocateWork, fAs.canAccessCliniciansView],
      'planner',
    ),
    '/TreatmentViewOld': route(
      TreatmentViewPageOld,
      CommunityLayoutCombined,
      [fAs.canAllocateWork, fAs.canAccessCliniciansView],
      'planner',
    ),
    '/ClinicianView': route(
      ClinicianViewPage,
      CommunityLayoutCombined,
      [fAs.canAllocateWork, fAs.canAccessCliniciansView],
      'planner',
    ),
    '/MapView': route(
      MapViewPage,
      CommunityLayoutCombined,
      [fAs.canAllocateWork, fAs.canAccessCliniciansView],
      'planner',
    ),
    '/ClinicianGroups': route(
      ClinicianGroupPage,
      CommunityLayoutCombined,
      [fAs.canAllocateWork, fAs.canAccessCliniciansView],
      'planner',
    ),
    _default: route(
      TreatmentViewPage,
      CommunityLayoutCombined,
      [fAs.canAllocateWork, fAs.canAccessCliniciansView],
      'planner',
    ),
  },
  '/Dashboard': route(Dashboard, CommunityLayoutCombined, [fAs.canAccessDashboard], 'dashboard'),
  '/Admin': {
    _default: route(ActivityTypePage, CommunityLayoutCombined, [fAs.canTriggerSync], 'activityTypesPage'),
    '/Audit': route(AuditPage, CommunityLayoutCombined, [fAs.canTriggerSync], 'auditPage'),
    '/Reasons': route(ReasonsPage, CommunityLayoutCombined, [fAs.canTriggerSync], 'reasons'),
    '/Activities': route(ActivityPage, CommunityLayoutCombined, [fAs.canTriggerSync], 'activityPage'),
    '/SystemInfo': route(SystemInfo, CommunityLayoutCombined, [fAs.canTriggerSync], 'systemInformation'),
    '/ReferralConfig': route(ReferralConfig, CommunityLayoutCombined, [fAs.canTriggerSync], 'referralConfig'),
    '/MileageCap': route(MileageCap, CommunityLayoutCombined, [fAs.canTriggerSync], 'mileageCap'),
    '/ConfigureClinician': route(
      ConfigureClinician,
      CommunityLayoutCombined,
      [fAs.canTriggerSync],
      'configureClinician',
    ),
    '/ExternalProvider': route(
      ExternalProvider,
      CommunityLayoutCombined,
      [fAs.canTriggerSync, fAs.enableIntegrationMode],
      'externalProvider',
    ),
    '/AutoAllocateWeightings': route(
      AutoAllocateWeightings,
      CommunityLayoutCombined,
      [fAs.canTriggerSync],
      'autoAllocateWeightings',
    ),
    '/ActivityTypes': route(ActivityTypePage, CommunityLayoutCombined, [fAs.canTriggerSync], 'activityTypesPage'),
    '/NonPatientActivityTypes': {
      _default: route(
        NonPatientActivityTypesList,
        CommunityLayoutCombined,
        [fAs.canSetUpTeamMeetings],
        'activityTypesPage',
      ),
    },
    '/ConfigureTimeSlots': route(
      ConfigureTimeSlotsContainer,
      CommunityLayoutCombined,
      [fAs.canTriggerSync],
      'configureTimeSlots',
    ),
    '/CancellingParties': route(
      CancellingPartyPage,
      CommunityLayoutCombined,
      [fAs.canTriggerSync],
      'cancellingPartyPage',
    ),
    // '/ConfigureAssistedPlanner': route(
    //   ConfigureAssistedPlannerPage,
    //   CommunityLayoutCombined,
    //   [fAs.canTriggerSync],
    //   'configureAssistedPlanner',
    // ),
  },
  '/DailyPlanning': route(DailyPlanning, CommunityLayoutCombined, [fAs.showDailyPlanningView], 'dailyPlanning'),
  '/Patients/Patient/Create': route(PatientAdd, CommunityLayoutCombined, [fAs.canAddPatients], 'patientAdd'),
  '/Patients': {
    '/Search': route(PatientSearchPage, CommunityLayoutCombined, [fAs.canAddReferrals], 'patients'),
    '/Audit': route(PatientAuditSearchPage, CommunityLayoutCombined, [fAs.canAddReferrals], 'patients'),
    '/ReferralsAudit': route(PatientSearchPage, CommunityLayoutCombined, [fAs.canAddReferrals], 'patients'),
    '/:patientId': {
      '/Referrals': {
        '/Create': route(ReferralCreate, CommunityLayoutCombined, [fAs.canAddReferrals], 'referralCreate'),
        _default: route(
          PatientReferrals,
          CommunityLayoutCombined,
          [fAs.canAddReferrals, fAs.canEditReferrals, fAs.canAddTreatments, fAs.canEditTreatments],
          'patientReferrals',
        ),
      },
      _default: route(
        PatientDetails,
        CommunityLayoutCombined,
        [
          fAs.canAddPatients,
          fAs.canEditPatients,
          fAs.canAddReferrals,
          fAs.canEditReferrals,
          fAs.canAddTreatments,
          fAs.canEditTreatments,
        ],
        'patient',
      ),
    },
    _default: route(
      PatientSearchPage,
      CommunityLayoutCombined,
      [
        fAs.canAddPatients,
        fAs.canEditPatients,
        fAs.canAddReferrals,
        fAs.canEditReferrals,
        fAs.canAddTreatments,
        fAs.canEditTreatments,
      ],
      'patientSearch',
    ),
  },
  '/Patients/Patient/Referrals': {
    '/:referralId': route(
      ReferralView,
      CommunityLayoutCombined,
      [fAs.canAddReferrals, fAs.canEditReferrals, fAs.canAddTreatments, fAs.canEditTreatments],
      'referralView',
    ),
    '/:id(\\d+)/Treatments/Create': route(
      TreatmentCreate,
      CommunityLayoutCombined,
      [fAs.canAddTreatments],
      'treatmentCreate',
    ),
    '/:id(\\d+)/Treatments/CreateRetroVisit': route(
      TreatmentCreateRetroVisit,
      CommunityLayoutCombined,
      [fAs.canAddTreatments],
      'treatmentCreateRetroVisit',
    ),
  },
  '/Reports': route(ReportSelection, CommunityLayoutCombined, [fAs.canAccessReports], 'reports'),
  '/Treatments/:id(\\d+)': route(TreatmentEdit, CommunityLayoutCombined, [fAs.canEditTreatments], 'treatmentEdit'),
  '/VisitActuals': {
    '/:visitActualId': route(VisitActualEdit, CommunityLayoutCombined, [fAs.canActualisePatientVisits], 'visitActual'),
    _default: route(VisitActualsPage, CommunityLayoutCombined, [fAs.canActualisePatientVisits], 'visitActuals'),
  },
  '/NonPatientActivities': {
    '/Create': route(
      NonPatientActivityCreate,
      CommunityLayoutCombined,
      [fAs.canSetUpTeamMeetings],
      'nonPatientActivityCreationPage',
    ),
    '/Edit/:id(\\d+)': route(
      NonPatientActivityEdit,
      CommunityLayoutCombined,
      [fAs.canSetUpTeamMeetings],
      'nonPatientActivityEditionPage',
    ),
    _default: route(
      NonPatientActivitiesPage,
      CommunityLayoutCombined,
      [fAs.canSetUpTeamMeetings],
      'nonPatientActivities',
    ),
  },
  '/RequestLogs': route(RequestLogsPage, CommunityLayoutCombined, [fAs.enableIntegrationMode], 'providerRequestLogs'),
};

const routes = buildNestedRouting(routingMap);
export default routes;
